import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class SupervisorRequestService extends Service {
	constructor(injector: Injector) {
		super("SupervisorRequest", injector);
	}
	
	// API
	allOpen(){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/AllOpen`);
	}

	openForMachine(machineId: number){
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/OpenForMachine/${machineId}`);
	}

	performanceDashboard(siteId?: number) {
		const url = siteId
			? `${environment.server.apiURL}/${this.endpoint}/PerformanceDashboard/${siteId}`
			: `${environment.server.apiURL}/${this.endpoint}/PerformanceDashboard`;
		return this.http.get(url);
	}
}